// extracted by mini-css-extract-plugin
export default {"imageWrapper":"vV-z","hovered":"wV-z","hoverImage":"xV-z","mainImage":"yV-z","imageNoBackground":"zV-z","fullSizeImage":"AV-z"};